import { useState } from "react";
import { Input } from "./ui/input";

// text input that shows every saved colour on focus (filters only after typing)
export const ColorInput = ({ listId, value, onChange, testId, className = "", ...rest }) => {
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState(false);
  const [hi, setHi] = useState(-1);
  const all = open ? [...(document.getElementById(listId)?.options || [])].map((o) => o.value) : [];
  const q = (value || "").toLowerCase();
  const opts = typed && q ? all.filter((v) => v.toLowerCase().includes(q)) : all;
  const pick = (v) => { onChange(v); setOpen(false); setHi(-1); };
  const onKey = (e) => {
    if (!open) { if (e.key === "ArrowDown") setOpen(true); return; }
    if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); setOpen(false); }
    else if (e.key === "ArrowDown") { e.preventDefault(); setHi((h) => Math.min(h + 1, opts.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setHi((h) => Math.max(h - 1, 0)); }
    else if (e.key === "Enter" && hi >= 0 && opts[hi]) { e.preventDefault(); pick(opts[hi]); }
  };
  return (
    <div className="relative self-end">
      <Input data-testid={testId} autoComplete="off" value={value || ""} className={className} data-color-open={open && opts.length > 0 ? "1" : undefined} {...rest}
        onFocus={() => { setOpen(true); setTyped(false); setHi(-1); }} onBlur={() => setOpen(false)} onKeyDown={onKey}
        onChange={(e) => { setTyped(true); setOpen(true); setHi(-1); onChange(e.target.value); }} />
      {open && opts.length > 0 && (
        <div data-testid={`${testId}-options`} className="absolute left-0 min-w-full w-max max-w-[260px] top-full z-50 mt-1 max-h-52 overflow-y-auto rounded-md border border-[#2D333F] bg-[#181B21] py-1 shadow-xl">
          {opts.map((v, i) => (
            <button type="button" key={v} data-testid={`${testId}-option-${i}`}
              onMouseDown={(e) => { e.preventDefault(); pick(v); }} onMouseEnter={() => setHi(i)}
              className={`block w-full truncate px-3 py-1.5 text-left text-sm ${i === hi ? "bg-[#E67E22]/20" : ""} ${v === value ? "text-[#E67E22]" : ""}`}>{v}</button>
          ))}
        </div>
      )}
    </div>
  );
};
